<template>
  <div style="display: inline-block">
    <b-button
      variant="warning"
      :class="buttonClass"
      :disabled="disabled"
      size="sm"
      pill
      @click="showConfirmModal"
    >
      쉐도우밴
    </b-button>

    <b-modal
      v-model="confirmModalShow"
      hide-footer
      hide-header
      style="text-align: center"
    >
      <h5 style="text-align: center">
        해당 유저를 쉐도우밴 하시겠습니까?
      </h5>
      <div class="d-block text-center lg">
        <b-button
          variant="success"
          pill
          @click="executeBan"
          :disabled="isExecuting"
          style="margin-right: 15px"
        >
          <b-spinner v-if="isExecuting" small></b-spinner>
          {{ isExecuting ? '처리중...' : '확인' }}
        </b-button>
        <b-button
          variant="danger"
          pill
          @click="cancel"
          :disabled="isExecuting"
          style="margin-left: 15px"
        >
          취소
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { approvalPool } from "../apis/index.js";

export default {
  name: "ShadowBanButton",
  props: {
    userId: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: "resultBtn"
    }
  },
  data() {
    return {
      confirmModalShow: false,
      isExecuting: false
    };
  },
  methods: {
    buildHeaders() {
      return { Authorization: this.$session.get("token") };
    },
    buildCountryParams() {
      const country = this.$session.get("country");
      if (typeof country === "string" && country.length > 0) {
        return { country };
      }
      return {};
    },
    showConfirmModal() {
      this.confirmModalShow = true;
    },
    cancel() {
      this.confirmModalShow = false;
    },
    async executeBan() {
      this.isExecuting = true;
      try {
        const response = await approvalPool.updateUserApproval(
          {
            id: this.userId,
            approvalAction: approvalPool.APPROVAL_ACTIONS.SHADOW_BAN
          },
          this.buildCountryParams(),
          this.buildHeaders()
        );

        this.confirmModalShow = false;

        this.$toast.success("유저가 쉐도우밴 처리되었습니다.", {
          position: "top",
          duration: 2000,
        });

        this.$emit('ban-success', {
          userId: this.userId,
          response
        });
      } catch (error) {
        console.error("Failed to shadow ban user:", error);
        this.$toast.error("쉐도우밴 처리 중 오류가 발생했습니다.", {
          position: "top",
          duration: 2000,
        });
        this.$emit('ban-error', {
          userId: this.userId,
          error
        });
      } finally {
        this.isExecuting = false;
      }
    }
  }
};
</script>

<style scoped>
.resultBtn {
  margin: 5px 10px 0px 10px;
  word-break: keep-all;
  word-wrap: normal;
}
</style>
